import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export class ServiceHttpBase{
    //public baseURL="http://localhost/patgonline/";
    //public baseURL=`{$envire}`;
    public baseURL=`${environment.apiUrl}`;
}